import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'ui';

import './_practice-return-to-tutor.scss';

type PracticeReturnToTutorProps = {
  onClose: () => void;
};

/**
 * PracticeReturnToTutor - Last screen of a tab launched from the study chat (TANAI-2622), shown
 * when the browser keeps the tab open after `window.close()`. It never navigates anywhere else: a
 * route like «Hoy» would turn this tab into one more study chat.
 *
 * The heading takes the focus on mount because the control the student just used (the dialog
 * button or «¡Hecho!») is gone, and focus would otherwise fall back to the document body.
 */
function PracticeReturnToTutor({ onClose }: Readonly<PracticeReturnToTutorProps>): JSX.Element {
  const { t } = useTranslation(['chatbot']);
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <section className="practice-return-to-tutor">
      <span aria-hidden="true" className="practice-return-to-tutor__mascot" />
      <h1 className="practice-return-to-tutor__title" ref={headingRef} tabIndex={-1}>
        {t('chatbot:practice_return_to_tutor_title')}
      </h1>
      <p className="practice-return-to-tutor__body">{t('chatbot:practice_return_to_tutor_body')}</p>
      <Button onClick={onClose} text={t('chatbot:practice_return_to_tutor_close')} variant="primary" />
    </section>
  );
}

export default PracticeReturnToTutor;
